import { render, staticRenderFns } from "./MilestonesDisplay.vue?vue&type=template&id=7d0ad72a&scoped=true&"
import script from "./MilestonesDisplay.vue?vue&type=script&lang=ts&"
export * from "./MilestonesDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./MilestonesDisplay.vue?vue&type=style&index=0&id=7d0ad72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0ad72a",
  null
  
)

export default component.exports